var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreInfoArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-expand_arrow 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.19378 1.98834L7.19104 1.98842C7.08535 1.99158 6.98401 2.03539 6.90906 2.11231L4.00037 5.02101L1.09166 2.11229C1.01288 2.03149 0.90765 1.99048 0.802747 1.98896L0.802748 1.98889L0.796742 1.98895C0.631022 1.99053 0.483073 2.09046 0.419604 2.24278L0.419586 2.24277L0.41842 2.24568C0.356637 2.39934 0.392731 2.57498 0.511397 2.69164L3.71047 5.89071C3.8706 6.05084 4.13014 6.05084 4.29028 5.89071L7.48891 2.69208C7.60963 2.57436 7.64483 2.39535 7.58149 2.24175L7.5815 2.24175L7.58065 2.23973C7.51551 2.08562 7.36288 1.98516 7.19378 1.98834Z",
    fill: "#4D4D4D",
    stroke: "#4D4D4D",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreInfoArrow);
export default __webpack_public_path__ + "static/media/moreInfoArrow.f2f1abd2dcbd92993c6eff98007b246d.svg";
export { ForwardRef as ReactComponent };